import { SxProps, Theme } from "@mui/material";

// Estilos compartidos por las pantallas de OC (creador, editor e histórico).
// Vivían duplicados e inconsistentes en cada página — unas tarjetas con las
// esquinas por defecto de MUI (4px) frente al resto de la app, y dos tablas
// con cabeceras distintas entre sí. Centralizarlos evita que vuelvan a
// separarse.

// Tarjeta de sección. El borde y la ausencia de sombra ya los impone el
// override global de MuiPaper en el tema, así que aquí solo va la forma.
export const OC_CARD_SX: SxProps<Theme> = {
  borderRadius: 3,
  p: { xs: 2, md: 2.5 },
};

// Cabecera de tabla: misma pauta que el resto de tablas de la app
// (mayúsculas, 12px, tracking abierto y color secundario sobre una banda
// neutra). En el histórico las celdas llevan TableSortLabel, que hereda este
// color y pasa a text.primary cuando la columna está activa.
//
// Es una factory en lugar de un objeto para poder componerla con otros
// estilos (`sx={(theme) => ({ ...ocTableHeadSx(theme), minWidth: 720 })}`);
// la forma de array de `sx` no encaja con el tipado de Table en MUI v5.
export const ocTableHeadSx = (theme: Theme) => ({
  "& th": {
    fontWeight: 700,
    fontSize: "12px",
    textTransform: "uppercase" as const,
    letterSpacing: "0.04em",
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.neutral["100"],
    borderBottom: `1px solid ${theme.palette.divider}`,
    whiteSpace: "nowrap" as const,
  },
});
